import { ADMIN_DOMAINS } from './adminNavConfig';

const ALLOWED_PARTNER_TOOL_IDS = new Set([
  'inbox',
  'runtime-status',
  'inference-health',
  'api-logs',
  'audit-trail',
  'user-spend',
  'slide-gaps',
  'coverage',
  'slide-coverage',
  'atom-explorer',
  'graph',
  'upload-cache',
  'deck-codes',
  'drug-storage',
  'dlc-packs',
  'reservoir',
  'brand-assets',
  'marketing',
  'concept-teaching',
  'boss-combat',
  'cram-map-proposals',
  'sandbox',
  'responsive-viewer',
  'multiplayer',
  'perpetual-services',
  'settings',
]);

function stripToolRoleMetadata(tool) {
  const { requires, ...partnerTool } = tool;
  return partnerTool;
}

export const PARTNER_ADMIN_DOMAINS = ADMIN_DOMAINS
  .map((domain) => {
    const tools = domain.tools
      .filter((tool) => ALLOWED_PARTNER_TOOL_IDS.has(tool.id))
      .map(stripToolRoleMetadata);

    if (!tools.length) {
      return null;
    }

    return {
      ...domain,
      tools,
      defaultTool: tools.some((tool) => tool.id === domain.defaultTool)
        ? domain.defaultTool
        : tools[0].id,
    };
  })
  .filter(Boolean);

export default PARTNER_ADMIN_DOMAINS;
